import axios from 'axios';
import { ElMessage } from 'element-plus';
import { baseURL } from './handelRes';
// import { getToken } from './auth';

// 创建axios实例
const service = axios.create({
    // baseURL: 'https://api.yijiaowang.net', // API的base_url
    baseURL: baseURL,
    // baseURL: 'https://www.yijiaowang.net',
    timeout: 200000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
    config => {
        // 如果存在token，请求携带token
        // const token = getToken();
        // if (token) {
        //     config.headers['Authorization'] = `Bearer ${token}`;
        // }

        // 确保Content-Type正确设置
        if (config.headers && config.headers['Content-Type'] === 'multipart/form-data') {
            // 对于文件上传，不要修改Content-Type，让浏览器自动设置正确的boundary
            // 某些axios版本会自动处理，但为了安全起见，这里显式处理
        }

        return config;
    },
    error => {
        console.log(error);
        Promise.reject(error);
    }
);

// response拦截器
service.interceptors.response.use(
    response => {
        // 304状态表示资源未修改，直接返回缓存数据
        //这里之后处理。
        if (response.data.status === true) {
            // console.log('资源未修改，使用缓存数据');
            return response.data;
        }

        const res = response.data;

        // 如果是文件下载，直接返回
        if (response.config.responseType === 'blob') {
            return response;
        }
        // console.log('res', res);
        return res;

        // 如果返回的不是200，说明接口有问题，应当提示错误信息
        // if (res.code !== 200 && res.code !== 0) {
        //     // ElMessage({
        //     //     message: res.message || '请求错误',
        //     //     type: 'error',
        //     //     duration: 5 * 1000,
        //     // });

        //     // token过期或未登录
        //     if (res.code === 401 || res.code === 403) {
        //         // 可以在这里处理登出逻辑
        //     }
        //     // return response.data;
        //     return Promise.reject(new Error(res.message || '请求错误'));
        // } else {
        //     return res;
        // }
    },
    error => {
        // console.log('err', error);
        // 对于特定错误类型，提供更具体的错误消息
        // let message = '请求失败';

        if (error.response) {
            // // 服务器返回了错误状态码
            // const status = error.response.status;
            // if (status === 400) {
            //     message =
            //         error.response.data?.message || '请求参数错误，请检查上传的文件格式和大小';
            // } else if (status === 401) {
            //     message = '未授权，请重新登录';
            // } else if (status === 403) {
            //     message = '拒绝访问，没有权限';
            // } else if (status === 404) {
            //     message = '请求的资源不存在';
            // } else if (status === 500) {
            //     message = '服务器错误，请联系管理员';
            // }
        } else if (error.request) {
            // 请求发出后没有收到响应
            // message = '网络错误，请检查网络连接';
        } else {
            // 请求配置出错
            // message = '请求配置错误';
        }

        // ElMessage({
        //     message: message,
        //     type: 'error',
        //     duration: 5 * 1000,
        // });
        return Promise.reject(error);
    }
);

export default service;
